import React, {HTMLProps, ReactElement} from "react";
import ChevronUp from "../designSystem/icons/ChevronUp";
import ChevronDown from "../designSystem/icons/ChevronDown";
import Checked from "../designSystem/icons/Checked";
import Title from "../designSystem/Title";


export interface ContainerProps extends HTMLProps<HTMLDivElement> {
    containerTitle?: string;
    containerDescription?: string;
    titleNumber? : number;
    infoPanel?: InfoPanel;
    close?: boolean;
    setClose?: () => void;
    validated?: boolean;
}

export interface InfoPanel {
    message: string;
    type: InfoPannelType
}

export enum InfoPannelType { SUCCESS, ERROR}

const Container = (props: ContainerProps): ReactElement => {

    const {
      className,
      infoPanel,
      containerTitle,
      containerDescription,
      titleNumber,
      close,
      setClose,
      validated,
      ...otherProps
    } = props;

    return (
        <div className={`${className || ""} flex flex-col overflow-hidden`} {...otherProps} >
            {!!infoPanel &&
                <div className={`${infoPanel.type === InfoPannelType.SUCCESS ? "bg-green" : "bg-red"} p-3 text-white rounded-t-lg`}>{infoPanel.message}</div>
            }
            <div className={`flex flex-col p-8 gap-y-3 bg-grey-light rounded-b-lg ${!props.infoPanel ? "rounded-t-lg" : ""}`}>
                {!!containerTitle &&
                    <div className={`flex justify-between items-center gap-x-4`}>
                        <Title className={"flex gap-x-4"}>
                            {titleNumber && !validated &&
                                <span className={"rounded-full border-black border-2 w-8 h-8 flex justify-center items-center pb-0.5"}>
                                    {titleNumber}
                                </span>
                            }
                            {validated && <div className={"w-8 h-8"}><Checked /></div>}
                            <span>{containerTitle}</span>
                        </Title>
                        {!!setClose &&
                            <div className={"w-6 h-6 cursor-pointer"} onClick={() => !!setClose && setClose()} >
                                {close ? <ChevronDown /> : <ChevronUp />}
                            </div>
                        }
                    </div>
                }
                {containerDescription &&
                  <div className={'flex text-black text-sm italic whitespace-pre-line'}>{containerDescription}</div>
                }
                <div className={`overflow-hidden`} style={close ? {maxHeight: 0, transition: "max-height .5s ease-out"} : {maxHeight: "1000px", transition: "max-height .5s ease-in"}}>
                    <div className={containerTitle ? "pt-3 border-t border-t-grey--200" : ""}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Container